import React from 'react';

const ProgressBar = ({ current, total }) => {
    // Ensure 0-100% range
    const percentage = Math.min(100, Math.max(0, Math.round((current / (total || 1)) * 100)));

    const style = {
        container: {
            width: '100%',
            height: '8px',
            backgroundColor: '#e0e0e0',
            borderRadius: '4px',
            margin: '20px 0',
            overflow: 'hidden'
        },
        fill: {
            height: '100%',
            width: `${percentage}%`,
            backgroundColor: '#007bff', // Primary color
            transition: 'width 0.3s ease-in-out'
        },
        text: {
            fontSize: '12px',
            color: '#666',
            textAlign: 'right',
            marginTop: '4px'
        }
    };

    return (
        <div>
            <div style={style.container}>
                <div style={style.fill}></div>
            </div>
            <div style={style.text}>{percentage}% 완료</div>
        </div>
    );
};

export default ProgressBar;
